







import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class CardListMenu extends Vue {
  @Prop() public icon!: string;
  @Prop({default:null}) public svg: string;  
  @Prop() public title!: string;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: null }) public sc: string;
  @Prop() public tooltip: string;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public event: boolean;  //GA4イベント

  public get titleSC() {
    if (this.sc == null) return this.$translate(this.title);
    else return this.$translate(this.title) + '(' + this.sc + ')';
  }
  //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する
  public created() {
    // if (this.sc != null) document.body.addEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.add(this.sc, this.onClick);
  }
  public mounted() {
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
  }
  public destroyed() {
    // if (this.sc != null) document.body.removeEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.remove(this.sc, this.onClick);
  }

  public onClick(): boolean {
    if (this.$api.perms.hasMenuPermission(this.perm) && this.enabled) {
      if(this.event)this.$api.issueGA4event(this.$route.path,this.titleSC);
      this.$emit('click');
    }
    return true;
  }
}
